/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Blog_EyebrowInputs */

const en_marketing_blog_eyebrow = /** @type {(inputs: Marketing_Blog_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

const es_marketing_blog_eyebrow = /** @type {(inputs: Marketing_Blog_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

const fr_marketing_blog_eyebrow = /** @type {(inputs: Marketing_Blog_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

/**
* | output |
* | --- |
* | "Blog" |
*
* @param {Marketing_Blog_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_blog_eyebrow = /** @type {((inputs?: Marketing_Blog_EyebrowInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Blog_EyebrowInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_blog_eyebrow(inputs)
	if (locale === "es") return es_marketing_blog_eyebrow(inputs)
	return fr_marketing_blog_eyebrow(inputs)
});